import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden"]

  update(e) {
    const input = e.target
    const tags = input.value.split(",").map(s => s.trim()).filter(Boolean)
    const form = input.closest("form")
    if (!form) return

    // Remove existing hidden tag inputs
    form.querySelectorAll("input[name='activity_catalog_entry[tags][]']").forEach(el => el.remove())

    // Create new hidden inputs for each tag
    tags.forEach(tag => {
      const hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = "activity_catalog_entry[tags][]"
      hidden.value = tag
      input.parentNode.appendChild(hidden)
    })
  }
}
